import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=2560f4c4&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=ts&"
export * from "./Apps.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/gstyle.css?vue&type=style&index=0&lang=css&"
import style1 from "./Apps.vue?vue&type=style&index=1&id=2560f4c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560f4c4",
  null
  
)

component.options.__file = "Apps.vue"
export default component.exports